import React, { useState, useEffect, useCallback } from 'react';
import { workflowsApi } from '../services/api';
import WorkflowProgressBar from './WorkflowProgressBar';

const STATUS_BADGE = {
  running:   { cls: 'status-info',    label: 'En cours' },
  completed: { cls: 'status-success', label: 'Terminé' },
  cancelled: { cls: 'status-error',   label: 'Annulé' },
};

const fmtDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '';

export default function WorkflowExecutionList({ user, editMode, isSuperAdmin, onOpen }) {
  const [executions, setExecutions] = useState([]);
  const [search, setSearch] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');
  const [loading, setLoading] = useState(true);
  const [selected, setSelected] = useState(new Set());

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await workflowsApi.listExecutions({
        search: search || undefined,
        status: statusFilter !== 'all' ? statusFilter : undefined,
      });
      setExecutions(data.executions || []);
      setSelected(new Set());
    } catch (e) {
      console.error('Erreur chargement exécutions', e);
    } finally {
      setLoading(false);
    }
  }, [search, statusFilter]);

  useEffect(() => { load(); }, [load]);

  const toggleSel = (id, e) => {
    e.stopPropagation();
    setSelected((prev) => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });
  };
  const bulkDelete = async () => {
    if (!window.confirm(`Supprimer ${selected.size} exécution(s) ?`)) return;
    try { await workflowsApi.bulkDeleteExecutions([...selected]); load(); }
    catch { alert('Échec de la suppression'); }
  };

  const canDelete = editMode && isSuperAdmin;

  return (
    <div className="wf-wide">
      <div className="page-toolbar">
        <input className="page-search" placeholder="🔍 Rechercher..." value={search} onChange={(e) => setSearch(e.target.value)} />
        <select className={`page-select ${statusFilter !== 'all' ? 'active-filter' : ''}`} value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="all">Tous les statuts</option>
          <option value="running">En cours</option>
          <option value="completed">Terminés</option>
          <option value="cancelled">Annulés</option>
        </select>
      </div>

      {canDelete && selected.size > 0 && (
        <div className="page-bulk-bar">
          <span>{selected.size} sélectionné(s)</span>
          <button className="btn-secondary" onClick={bulkDelete}>🗑️ Supprimer la sélection</button>
        </div>
      )}

      {loading ? (
        <div className="wf-loading">Chargement…</div>
      ) : executions.length === 0 ? (
        <div className="empty-state"><p>Aucune exécution.</p><p className="wf-muted">Lancez un modèle avec « + Lancer une exécution ».</p></div>
      ) : (
        <div className="table-container">
          <table>
            <thead>
              <tr>
                {canDelete && <th style={{ width: 36 }}></th>}
                <th>Nom</th>
                <th>Modèle</th>
                <th style={{ width: 180 }}>Progression</th>
                <th>Statut</th>
                <th>Lancé le</th>
                <th>Par</th>
              </tr>
            </thead>
            <tbody>
              {executions.map((e) => {
                const b = STATUS_BADGE[e.status] || STATUS_BADGE.running;
                return (
                  <tr key={e.id} onClick={() => onOpen(e.id)} style={{ cursor: 'pointer' }}>
                    {canDelete && (
                      <td onClick={(ev) => ev.stopPropagation()}>
                        <input type="checkbox" checked={selected.has(e.id)} onChange={(ev) => toggleSel(e.id, ev)} />
                      </td>
                    )}
                    <td><strong>{e.name}</strong>{e.entity_type && <div className="wf-muted wf-sm">{e.entity_type} {e.entity_id}</div>}</td>
                    <td><span className="wf-sm" style={{ color: e.template_color || 'var(--text-secondary)' }}>● {e.template_name}</span></td>
                    <td><WorkflowProgressBar pct={e.progress_pct} color={e.template_color} compact /><span className="wf-sm wf-muted">{e.steps_done}/{e.steps_total}</span></td>
                    <td><span className={`wf-exec-status ${e.status}`}>{b.label}</span></td>
                    <td className="wf-sm">{fmtDate(e.launched_at)}</td>
                    <td className="wf-sm">{e.launched_by_name}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
